import { getServices } from '../../infra/startup';
import { isNative as isNativeFromJWeb } from '../../services/JWeb';
import { bootstrapManager } from '../../infra/startup/bootstrapManager';
import UseLocaleContext from './useLocaleContext';
import UseLoggedInRules from './useLoggedInRules';
import UseIdleLogoutTimer from './useIdleLogoutTimer';
import InitBackgroundTaskManager from './InitBackgroundTaskManager';
import InitShellCallInterfaceNavigationPush from './InitClientosNavigationPushEventHandler';
import SyncAuthenticationDataOnJWebValueStore from './SyncAuthenticationDataOnJWebValueStore';
import { ClientOSInterfacesType } from '@clientos/types/dist';

export default class AfterInitBehaviors {
  public static init = async function (
    interfaces: ClientOSInterfacesType
  ): Promise<void> {
    const isNative = await isNativeFromJWeb();
    const { navigation } = interfaces.v1;

    const {
      tenantHandlerService,
      sessionService,
      navigationService,
      localizationService,
      webServiceRouting,
      idleLogoutService,
      logoutService,
      loginService,
      backgroundTaskManagerService,
      eventService,
      userService
    } = getServices();

    // Phase 9: Post-Integration Finalization
    bootstrapManager.setPostIntegration();

    const useLoggedInRules = new UseLoggedInRules({
      navigationService,
      sessionService,
      tenantHandlerService
    });

    const useLocaleContext = new UseLocaleContext({
      navigationService,
      localizationService,
      webServiceRouting
    });

    const useIdleLogoutTimer = new UseIdleLogoutTimer({
      sessionService,
      loginService,
      idleLogoutService,
      logoutService
    });

    const initBackgroundTaskManager = new InitBackgroundTaskManager({
      backgroundTaskManagerService
    });

    const initClientosNavigationPushEvent =
      new InitShellCallInterfaceNavigationPush({
        navigation,
        eventService
      });

    const syncAuthenticationDataOnJWebValueStore =
      new SyncAuthenticationDataOnJWebValueStore({ userService });

    await initClientosNavigationPushEvent.init();
    initBackgroundTaskManager.init();

    await useLocaleContext.init();

    useIdleLogoutTimer.init();

    isNative && (await syncAuthenticationDataOnJWebValueStore?.init());
    await useLoggedInRules?.init?.();

    bootstrapManager.setSuccess();
  };
}
